import { render, staticRenderFns } from "./ActiveCodeGenerate.vue?vue&type=template&id=289c8b16&scoped=true&"
import script from "./ActiveCodeGenerate.vue?vue&type=script&lang=js&"
export * from "./ActiveCodeGenerate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289c8b16",
  null
  
)

export default component.exports